import React from "react";
import { useAttendance } from "../../../hooks/attendance/AttendanceContext";
import RelativeDateRangeNav from "components/Shared/RelativeDateRangeNav";

/**
 * Filtro de rango de fechas en supervisor de fichajes.
 */
const DateFilter = () => {
	const {
		filters: { dateRange, handleDateChange, activeDatePreset, setDatePreset },
	} = useAttendance();

	return (
		<RelativeDateRangeNav
			startDate={dateRange.start}
			endDate={dateRange.end}
			activeDatePreset={activeDatePreset}
			onDatesChange={handleDateChange}
			onPresetChange={setDatePreset}
		/>
	);
};

export default DateFilter;
